module.exports = __webpack_public_path__ + "assets/4f3b5057e9224c63b0fc76fffb6b3d26.png";